import {
  dsBase,
  dsDestructive,
  dsNeutral,
  dsOpacity,
  dsPrimary,
  dsPrimaryGradient,
  dsSecondaryBrown,
  dsSecondaryGradient,
  dsSecondaryPurple,
  dsSecondaryYellow,
  dsSuccess,
  dsSurface,
  dsWarning,
} from "./palettes/app-palette";
import {
  vrAmber,
  vrBase,
  vrBrandBlue,
  vrGreen,
  vrNeutralDark,
  vrNeutralLight,
  vrOrange,
  vrPurple,
  vrRed,
  vrSurfaceDark,
  vrSurfaceLight,
  vrYellow,
} from "./palettes/vr-palette";

export const sharedPalette = {
  dsNeutral: {
    v100: dsNeutral.v100,
    v200: dsNeutral.v200,
    v300: dsNeutral.v300,
    v400: dsNeutral.v400,
    v500: dsNeutral.v500,
  },
  dsPrimary: {
    v100: dsPrimary.v100,
    v200: dsPrimary.v200,
    v300: dsPrimary.v300,
    v400: dsPrimary.v400,
  },
  dsSuccess: {
    v100: dsSuccess.v100,
    v200: dsSuccess.v200,
    v300: dsSuccess.v300,
    v400: dsSuccess.v400,
  },
  dsWarning: {
    v100: dsWarning.v100,
    v200: dsWarning.v200,
    v300: dsWarning.v300,
    v400: dsWarning.v400,
  },
  dsDestructive: {
    v100: dsDestructive.v100,
    v200: dsDestructive.v200,
    v300: dsDestructive.v300,
    v400: dsDestructive.v400,
  },
  dsSecondaryPurple: {
    v100: dsSecondaryPurple.v100,
    v200: dsSecondaryPurple.v200,
    v300: dsSecondaryPurple.v300,
    v400: dsSecondaryPurple.v400,
  },
  dsSecondaryBrown: {
    v100: dsSecondaryBrown.v100,
    v200: dsSecondaryBrown.v200,
    v300: dsSecondaryBrown.v300,
    v400: dsSecondaryBrown.v400,
  },
  dsSecondaryYellow: {
    v100: dsSecondaryYellow.v100,
    v200: dsSecondaryYellow.v200,
    v300: dsSecondaryYellow.v300,
    v400: dsSecondaryYellow.v400,
  },
  dsPrimaryGradient: {
    ...dsPrimaryGradient,
  },
  dsSecondaryGradient: {
    ...dsSecondaryGradient,
  },
  dsOpacity: {
    ...dsOpacity,
  },
};

const vrPaletteCommon = {
  dsBrandBlue: {
    v100: vrBrandBlue.v100,
    v200: vrBrandBlue.v200,
  },
  dsPurple: {
    v100: vrPurple.v100,
    v200: vrPurple.v200,
    v300: vrPurple.v300,
  },
  dsGreen: {
    v100: vrGreen.v100,
    v200: vrGreen.v200,
    v300: vrGreen.v300,
  },
  dsRed: {
    v100: vrRed.v100,
    v200: vrRed.v200,
    v300: vrRed.v300,
  },
  dsOrange: {
    v100: vrOrange.v100,
    v200: vrOrange.v200,
    v300: vrOrange.v300,
  },
  dsYellow: {
    v100: vrYellow.v100,
    v200: vrYellow.v200,
    v300: vrYellow.v300,
  },
  dsAmber: {
    v100: vrAmber.v100,
    v200: vrAmber.v200,
  },
};

export const vrPaletteLight = {
  dsBase: {
    v100: vrBase.v100,
    v200: vrBase.v200,
  },
  dsNeutral: {
    v100: vrNeutralLight.v100,
    v200: vrNeutralLight.v200,
    v300: vrNeutralLight.v300,
    v400: vrNeutralLight.v400,
    v500: vrNeutralLight.v500,
  },
  dsSurface: {
    v100: vrSurfaceLight.v100,
    v200: vrSurfaceLight.v200,
    v300: vrSurfaceLight.v300,
    v400: vrSurfaceLight.v400,
    v500: vrSurfaceLight.v500,
  },
  ...vrPaletteCommon,
};

export const vrPaletteDark = {
  dsBase: {
    v100: vrBase.v200,
    v200: vrBase.v100,
  },
  dsNeutral: {
    v100: vrNeutralDark.v100,
    v200: vrNeutralDark.v200,
    v300: vrNeutralDark.v300,
    v400: vrNeutralDark.v400,
    v500: vrNeutralDark.v500,
  },
  dsSurface: {
    v100: vrSurfaceDark.v100,
    v200: vrSurfaceDark.v200,
    v300: vrSurfaceDark.v300,
    v400: vrSurfaceDark.v400,
    v500: vrSurfaceDark.v500,
  },
  ...vrPaletteCommon,
};

export const mobilePaletteLight = {
  dsBase: {
    v100: dsBase.v100,
    v200: dsBase.v200,
  },
  dsSurface: {
    v100: dsSurface.v100,
    v200: dsSurface.v200,
    v300: dsSurface.v300,
    v400: dsSurface.v400,
    v500: dsSurface.v500,
  },
};

export const mobilePaletteDark = {
  dsBase: {
    v100: dsBase.v200,
    v200: dsBase.v100,
  },
  dsSurface: {
    v100: dsNeutral.v500,
    v200: dsNeutral.v400,
    v300: dsNeutral.v300,
    v400: dsNeutral.v200,
    v500: dsNeutral.v100,
  },
};

export const portalPaletteLight = {
  dsBase: {
    v100: dsBase.v100,
    v200: dsBase.v200,
  },
  dsSurface: {
    v100: dsSurface.v100,
    v200: dsSurface.v200,
    v300: dsSurface.v300,
    v400: dsSurface.v400,
    v500: dsSurface.v500,
  },
};

export const portalPaletteDark = {
  dsBase: {
    v100: dsBase.v200,
    v200: dsBase.v100,
  },
  dsSurface: {
    v100: dsNeutral.v500,
    v200: dsNeutral.v400,
    v300: dsNeutral.v300,
    v400: dsNeutral.v200,
    v500: dsNeutral.v100,
  },
};